module.exports = __webpack_public_path__ + "didnt-purchase.svg?e055f4f43be83a35b51e50b3408abdc6";